import * as types from "./types";
import INITIAL_STATE from "./init";

// style guide: avoid destructuring state

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_TAKER:
      return { ...state, ...action.payload };
    case types.SET_TOKEN:
      return { ...state, token: action.payload };
    case types.SET_SUBMITTED_COUNT:
      return { ...state, submitted: action.payload };
    case types.INCREMENT_SUBMITTED_COUNT:
      return { ...state, submitted: state.submitted + 1 };
    case types.SET_SESSION_ID:
      return { ...state, sessionId: action.payload };
    case types.SET_2FA_AS_REQUIRED:
      return { ...state, use2FA: true };
    default:
      return state;
  }
};
